import React from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, Typography } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { t } from 'state/intl/translations';
import { primitive, spacing } from 'styles/constants';

interface ChooseLocationType {
  testID?: string;
}

const ArrowRightIcon = Icon.withConfig({
  variant: 'back',
  size: {
    base: 'xs',
    md: 'sm',
  },
  mt: {
    base: '$1',
    md: '$0',
  },
  style: {
    transform: [{ rotate: '180deg' }],
  },
});

const ChooseLocation = ({ testID }: ChooseLocationType) => {
  const chooseYourLocation = t('chooseYourLocation');
  const isDesktop = useIsDesktopBreakpoint();

  return (
    <Box
      testID={testID}
      accessibilityLabel={chooseYourLocation}
      accessibilityHint={t('clickToSelectLocation')}
      style={[styles.container, isDesktop && styles.desktopContainer]}
    >
      <Typography style={[styles.label, isDesktop && styles.desktopLabel]}>
        {chooseYourLocation}
      </Typography>
      <ArrowRightIcon />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginLeft: spacing.$2,
    paddingTop: spacing.$1,
  },
  desktopContainer: { marginRight: spacing.$4 },
  desktopLabel: { fontSize: 16 },
  label: { color: primitive.$bbqBrown, fontSize: 14 },
});

export default ChooseLocation;
